import React from 'react';
import MonacoEditor from '@monaco-editor/react';

type Props = {
	height: string;
	readOnly: boolean;
	value: string;
	background?: string;
	foreground?: string;
	theme?: 'vs' | 'vs-dark'
	onMount?: (editor: any) => void;
	style?: React.CSSProperties
};

export function Editor(props: Props) {
	const {
		value,
		readOnly,
		height,
		onMount = () => {},
		background = '#141B34',
		foreground = '#FFFFFF',
		theme = 'vs-dark',
		style = {}
	} = props;
	return (
		<div style={{ background, padding: 4, borderRadius: 6, ...style }}>
			<MonacoEditor
				value={value}
				className="qna-editor"
				height={height}
				options={{
					contextmenu: false,
					minimap: {
						enabled: false,
					},
					tabSize: 2,
					fontSize: 14,
					lineNumbers: 'off',
					readOnly,
					scrollBeyondLastLine: false,
					renderLineHighlight: 'none',
					glyphMargin: false,
					folding: false,
					lineDecorationsWidth: 0,
					lineNumbersMinChars: 0,
					wordWrap: 'on',
					quickSuggestions: false,
					fixedOverflowWidgets: true,
					overviewRulerLanes: 0,
					parameterHints: {
						enabled: false,
					},
					suggest: {
						showFields: false,
						showFunctions: false,
					},
				}}
				language="javascript"
				theme="qnaTheme"
				keepCurrentModel={false}
				width="100%"
				beforeMount={(monaco) => {
					monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
						diagnosticCodesToIgnore: [2304],
					});
					monaco.editor.defineTheme('qnaTheme', {
						base: theme,
						inherit: true,
						rules: [
							{
								foreground: '#FF7230',
								token: 'string',
							},
							{
								foreground: '#1D7AFF',
								token: 'entity',
							},
						],
						colors: {
							'editor.background': background,
							'editor.foreground': foreground,
						},
					});
				}}
				onMount={onMount}
			/>
		</div>
	);
}
